
  <input class="is-checkradio is-primary" 
  [id]="id" 
  type="radio"
  [name]="id" 
  [checked]="checked">
  <label>{{label}}</label>
